document.addEventListener('DOMContentLoaded', function() {

  const fadeSelectors = [
    '.image-block--AQzhucDdhZ0R3RXNQc__image_L94EC4',
    '.text-block--AL1VqSVEwc1ZGaGZTb__text_jBF78Y',
    '.text-block--AamNvQjhONFA4amd5a__text_nMLrgK',
    '.hero__media-wrapper',
    '.text-block--AZWsxb0xPdmRnZCtpa__text_69C6UJ'
  ];

  fadeSelectors.forEach(selector => {
    const el = document.querySelector(selector);
    if (el) el.classList.add('fade-in');
  });

  // Reveal the landscape at its first visible edge, rather than waiting for
  // 15% of a tall image. Keep its heading visible with the image.
  const landscapeSection = document.querySelector('#MainContent[data-template="index"] [id$="__hero_MVUtj6"]');
  const landscape = landscapeSection?.querySelector('.hero__media-wrapper');
  if (landscape) {
    landscape.classList.add('fade-in');
    landscape.setAttribute('data-early-landscape', '');
    landscapeSection.querySelectorAll('.text-block').forEach(node => node.classList.remove('fade-in'));
    const pageWrapper = document.querySelector('.page-wrapper');
    const overflow = pageWrapper && getComputedStyle(pageWrapper).overflowY;
    const root = overflow === 'auto' || overflow === 'scroll' ? pageWrapper : null;
    const earlyReveal = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          earlyReveal.unobserve(entry.target);
        }
      }
    }, { root, rootMargin: '0px 0px 120px 0px', threshold: 0.01 });
    earlyReveal.observe(landscape);
  }

  const targets = document.querySelectorAll('.fade-in:not([data-early-landscape])');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, i * 100);
      } else {
        entry.target.classList.remove('visible');
      }
    });
  }, { threshold: 0.15 });

  targets.forEach(el => observer.observe(el));
});


(() => {
  const updateOverscrollColor = () => {
    const container = matchMedia('(min-width: 990px)').matches
      ? document.querySelector('.page-wrapper') : document.scrollingElement;
    if (!container) return;
    const limit = container.scrollHeight - container.clientHeight;
    const color = '#243a2f';
    document.documentElement.style.setProperty('--tarim-overscroll-color', color);
  };
  document.addEventListener('scroll', updateOverscrollColor, { passive: true, capture: true });
  window.addEventListener('resize', updateOverscrollColor, { passive: true });
  window.addEventListener('pageshow', updateOverscrollColor);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateOverscrollColor, { once: true });
  else updateOverscrollColor();
})();

/* Tarim product detail tabs: keep the original accordions for mobile. */
(() => {
  const desktop = matchMedia('(min-width: 990px)');
  const bound = new WeakMap();
  let queued = false;
  function setup() {
    document.querySelectorAll('#MainContent .product-details').forEach((details, groupIndex) => {
      const buy = details.querySelector('.buy-buttons-block');
      const terms = details.querySelector('product-price .installments');
      if (buy && terms) {
        details.querySelectorAll('.tarim-payment-terms').forEach(old => old.remove());
        terms.classList.add('tarim-payment-terms');
        buy.after(terms);
      }
      const accordion = details.querySelector('.accordion');
      if (!accordion || bound.get(details)?.accordion === accordion) return;
      const rows = [...accordion.querySelectorAll('details')];
      if (!rows.length) return;
      details.querySelector('.tarim-product-tabs')?.remove();
      const tabs = document.createElement('div');
      tabs.className = 'tarim-product-tabs';
      const list = document.createElement('div');
      list.className = 'tarim-product-tabs__nav';
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', 'Product details');
      list.setAttribute('aria-orientation', 'vertical');
      const content = document.createElement('div');
      content.className = 'tarim-product-tabs__panels';
      const buttons = [], panels = [];
      const select = (index, focus = false) => {
        buttons.forEach((button, i) => {
          button.setAttribute('aria-selected', String(i === index));
          button.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) buttons[index].focus();
      };
      rows.forEach((row, i) => {
        const key = `tarim-details-${groupIndex}-${i}`;
        const button = document.createElement('button');
        button.type = 'button';
        button.id = `${key}-tab`;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', `${key}-panel`);
        button.textContent = row.querySelector('summary').textContent.trim();
        const panel = document.createElement('div');
        panel.id = `${key}-panel`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', button.id);
        panel.tabIndex = 0;
        const source = row.querySelector('.details-content');
        if (source) [...source.childNodes].forEach(node => panel.append(node.cloneNode(true)));
        button.addEventListener('click', () => select(i));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowDown') next = (i + 1) % rows.length;
          if (event.key === 'ArrowUp') next = (i + rows.length - 1) % rows.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = rows.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
        buttons.push(button); panels.push(panel);
        list.append(button); content.append(panel);
      });
      tabs.append(list, content);
      accordion.before(tabs);
      accordion.classList.add('tarim-mobile-details');
      select(0);
      const measure = () => {
        const header = document.querySelector('.header-section')?.getBoundingClientRect().height || 0;
        const crumb = document.querySelector('.tarim-breadcrumbs')?.getBoundingClientRect().height || 0;
        details.toggleAttribute('data-tarim-tall', desktop.matches && details.offsetHeight > innerHeight - header - crumb - 16);
      };
      const observer = new ResizeObserver(measure);
      bound.get(details)?.observer.disconnect();
      observer.observe(details);
      bound.set(details, {accordion, observer});
      window.addEventListener('resize', measure);
      measure();
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; setup(); });
  }
  function init() {
    setup();
    const main = document.querySelector('#MainContent');
    if (main) new MutationObserver(schedule).observe(main, {childList: true, subtree: true});
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();



/* A small gallery indicator observes native scrolling; it never intercepts wheels. */
(() => {
  function init() {
    const root = document.querySelector('.page-wrapper');
    if (!root) return;
    const bar = document.createElement('div');
    bar.className = 'tarim-gallery-scrollbar';
    bar.setAttribute('role', 'scrollbar');
    bar.setAttribute('aria-label', 'Product photos');
    bar.setAttribute('aria-orientation', 'vertical');
    bar.setAttribute('aria-valuemin', '0');
    bar.tabIndex = 0;
    const thumb = document.createElement('span');
    thumb.className = 'tarim-gallery-scrollbar__thumb';
    bar.append(thumb);
    document.body.append(bar);
    let frame = 0, range = 0, start = 0, trackTop = 0, trackHeight = 0, thumbHeight = 0;
    function update() {
      frame = 0;
      const media = document.querySelector('#MainContent .product-information__media');
      if (!media || !matchMedia('(min-width:990px)').matches) { bar.hidden = true; return; }
      const rect = media.getBoundingClientRect();
      const header = document.querySelector('.header-section')?.getBoundingClientRect().height || 0;
      const crumbs = document.querySelector('.tarim-breadcrumbs')?.getBoundingClientRect().height || 0;
      const offset = header + crumbs;
      const visibleHeight = Math.max(0, innerHeight - offset - 16);
      start = root.scrollTop + rect.top - offset;
      range = Math.max(0, rect.height - visibleHeight);
      trackTop = Math.max(offset, rect.top);
      trackHeight = Math.min(innerHeight - 16, rect.bottom) - trackTop;
      bar.hidden = range <= 0 || trackHeight < 24;
      if (bar.hidden) return;
      thumbHeight = Math.min(trackHeight, Math.max(24, trackHeight * visibleHeight / rect.height));
      const progress = Math.max(0, Math.min(1, (root.scrollTop - start) / range));
      bar.style.left = `${rect.right - 2}px`;
      bar.style.top = `${trackTop}px`;
      bar.style.height = `${trackHeight}px`;
      thumb.style.height = `${thumbHeight}px`;
      thumb.style.transform = `translateY(${progress * (trackHeight - thumbHeight)}px)`;
      bar.setAttribute('aria-valuemax', String(Math.round(range)));
      bar.setAttribute('aria-valuenow', String(Math.round(progress * range)));
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    root.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    new ResizeObserver(schedule).observe(root);
    new MutationObserver(schedule).observe(document.querySelector('#MainContent') || root, {childList:true,subtree:true});
    bar.addEventListener('keydown', event => {
      const steps = {ArrowDown:40, ArrowUp:-40, PageDown:trackHeight, PageUp:-trackHeight};
      if (event.key === 'Home') root.scrollTop = start;
      else if (event.key === 'End') root.scrollTop = start + range;
      else if (event.key in steps) root.scrollTop += steps[event.key];
      else return;
      event.preventDefault();
    });
    bar.addEventListener('pointerdown', event => {
      bar.setPointerCapture(event.pointerId);
      const move = e => {
        const progress = Math.max(0, Math.min(1, (e.clientY - trackTop - thumbHeight / 2) / Math.max(1, trackHeight - thumbHeight)));
        root.scrollTop = start + progress * range;
      };
      move(event);
      bar.addEventListener('pointermove', move);
      bar.addEventListener('pointerup', () => bar.removeEventListener('pointermove', move), {once:true});
    });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();

/* Preserve the official Shop Promise branding without its large delivery box. */
(() => {
  let attempts = 0;
  const compact = () => {
    document.querySelectorAll('#MainContent delivery-promise-wc').forEach(host => {
      const root = host.shadowRoot;
      if (!root || root.querySelector('#tarim-promise-badge-only')) return;
      const style = document.createElement('style');
      style.id = 'tarim-promise-badge-only';
            style.textContent = '.PromiseShell__ShopPromise-SmoothContainer,.ContainerCommon__Container.ShopPromiseLayout__RelaunchV2{border:0!important;padding:0!important;background:transparent!important;box-shadow:none!important;min-height:0!important;border-radius:0!important}.ShopPromiseLayout__RelaunchV2>.BlockStack__BlockStack>.BlockStack__BlockStack>.BlockStack__BlockStack{display:none!important}.ShopPromiseLayout__RelaunchV2>.BlockStack__BlockStack{gap:0!important}';
      root.append(style);
    });
  };
  const init = () => {
    compact();
    const timer = setInterval(() => {compact(); if (++attempts >= 60) clearInterval(timer);}, 500);
    document.addEventListener('shopify:section:load', compact);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
